export const modifyMetricData = (data, units, currentUnit) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    if (!item || typeof item !== 'object') return item;

    const modifiedItem = { ...item };

    if (currentUnit !== 'US') {
      Object.keys(modifiedItem).forEach((key) => {
        const unit = units?.[key];
        if (unit && modifiedItem[key] !== undefined && unit?.conversionFactor) {
          const conversionFactor = Number(unit.conversionFactor || 1);
          const decimals = unit.decimals || 0;

          modifiedItem[key] = parseFloat((modifiedItem[key] * conversionFactor).toFixed(decimals));
        }
      });
    }

    return modifiedItem;
  });
};

export const modifyMetricDataArray = (data, units, currentUnit) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    if (!item || typeof item !== 'object') return item;

    Object.keys(item).forEach((key) => {
      const unit = units?.[key];

      if (currentUnit !== 'US' && unit?.conversionFactor) {
        const conversionFactor = Number(unit.conversionFactor || 1);
        const decimals = unit.decimals || 0;

        if (typeof item[key] === 'number') {
          item[key] = parseFloat((item[key] * conversionFactor).toFixed(decimals));
        }

        if (Array.isArray(item[key])) {
          item[key] = item[key].map((subItem) => {
            if (typeof subItem === 'number') {
              return parseFloat((subItem * conversionFactor).toFixed(decimals));
            }
            return subItem;
          });
        }
      }
    });

    return item;
  });
};

export const modifyMetricDataByKey = (data, units, currentUnit, unitKey) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    if (!item || typeof item !== 'object') return item;

    const modifiedItem = { ...item };

    const parameterKey = item?.[unitKey];

    if (currentUnit !== 'US') {
      Object.keys(modifiedItem).forEach((key) => {
        const unit = units?.[parameterKey];
        if (unit && modifiedItem[key] !== undefined && unit?.conversionFactor && typeof modifiedItem[key] === 'number') {
          const conversionFactor = Number(unit.conversionFactor || 1);
          const decimals = unit.decimals || 0;

          modifiedItem[key] = parseFloat((modifiedItem[key] * conversionFactor).toFixed(decimals));
        }
      });
    }

    return modifiedItem;
  });
};

export const modifyRolloverDisplacementResults = (data, units, currentUnit) => {
  if (!Array.isArray(data)) return [];

  const flattened = data.map((item) => {
    if (!item.depths_summary) return { ...item };

    const flat = { ...item };

    for (const depth in item.depths_summary) {
      const d = item.depths_summary[depth];

      if (d.esd_with_sbp ?? d.esd) {
        flat[`${depth}_esd`] = d.esd_with_sbp ?? d.esd;
      }

      if (d.ecd_with_sbp ?? d.ecd) {
        flat[`${depth}_ecd`] = d.ecd_with_sbp ?? d.ecd;
      }
    }

    return flat;
  });

  const converted = modifyMetricData(flattened, units, currentUnit);

  return converted.map((item) => {
    if (!item.depths_summary) return item;

    for (const depth in item.depths_summary) {
      const esdKey = `${depth}_esd`;
      const ecdKey = `${depth}_ecd`;

      if (item[esdKey] !== undefined) {
        item.depths_summary[depth].esd_with_sbp = item[esdKey];
        delete item[esdKey];
      }

      if (item[ecdKey] !== undefined) {
        item.depths_summary[depth].ecd_with_sbp = item[ecdKey];
        delete item[ecdKey];
      }
    }

    return item;
  });
};
